import { useStoreContext } from "../providers/store.provider";
import { IFeeInSale } from "../types/types";
import { processFee } from "../utils/fee.utils";
import { toFixedDisplay } from "../utils/number.utils";

/**
 * Breakdown of the fees a store charges on an online order. Rate reads as the
 * fee as configured (5% or a flat amount), Amount is what it adds to this bill.
 * @param itemTotal - fees are always charged off the item total, not the gross.
 */
export function FeesTable({
  fees,
  itemTotal,
}: {
  fees: IFeeInSale[];
  itemTotal: number;
}) {
  const { currency } = useStoreContext();

  if (fees.length === 0) {
    return null;
  }

  return (
    <div className="my-2 overflow-x-auto">
      <table className="w-full border-collapse border border-current/30 text-left text-sm">
        <thead>
          <tr>
            <th className="border border-current/30 px-2 py-1 font-bold">
              Fee
            </th>
            <th className="border border-current/30 px-2 py-1 font-bold">
              Rate
            </th>
            <th className="border border-current/30 px-2 py-1 text-right font-bold">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {fees.map((fee) => (
            <tr key={fee.id}>
              <td className="border border-current/30 px-2 py-1">{fee.name}</td>
              <td className="border border-current/30 px-2 py-1">
                {fee.type === "PERCENT"
                  ? `${fee.value}%`
                  : `${currency}${toFixedDisplay(fee.value)}`}
              </td>
              <td className="border border-current/30 px-2 py-1 text-right">
                {currency}
                {toFixedDisplay(processFee(itemTotal, fee))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
